import type { ReactNode } from 'react';
import { CarIcon, FhhIcon, FlightIcon, HotelIcon, PpIcon } from 'shared/seo/VerticalIcons';
import { validSeoPath } from 'shared/util/formatting';

type Destination = { city?: string; country: string };
type LinkTreeData = {
    title: string;
    prefix: string;
    path: string;
    destinations: Destination[];
    icon: ReactNode;
};

export const CurrencyLinkTree = () => {
    const renderTable = (data: LinkTreeData) => (
        <div key={`clt${data.title}`}>
            {data.icon}
            <div className="px-16 py-8 text-left font-bold s-bg-subtle">{data.title}</div>
            {data.destinations.map((destination) => (
                <div className="px-16 py-8 border-b" key={`clt${destination.city ?? destination.country}`}>
                    <a
                        href={`https://www.finn.no/reise/${data.path}/${validSeoPath(destination.country)}/${
                            destination.city ? `${validSeoPath(destination.city)}/` : ''
                        }`}
                        className="display-block s-text-subtle">
                        {data.prefix} {destination.city ?? destination.country}
                    </a>
                </div>
            ))}
        </div>
    );

    return (
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-32 my-32">
            {renderTable({
                title: 'Fly',
                prefix: 'Flybilletter til',
                path: 'flybilletter',
                destinations: [
                    { country: 'Spania' },
                    { country: 'USA' },
                    { country: 'Storbritannia' },
                    { country: 'Danmark' },
                    { country: 'Tyskland' },
                ],
                icon: FlightIcon,
            })}
            {renderTable({
                title: 'Hotell',
                prefix: 'Hotell i',
                path: 'hotell',
                destinations: [
                    { country: 'Storbritannia' },
                    { country: 'Danmark' },
                    { country: 'Sverige' },
                    { country: 'Polen' },
                    { country: 'Nederland' },
                ],
                icon: HotelIcon,
            })}
            {renderTable({
                title: 'Pakkereiser',
                prefix: 'Pakkereiser til',
                path: 'pakkereiser',
                destinations: [
                    { country: 'Spania' },
                    { country: 'Hellas' },
                    { country: 'Tyrkia' },
                    { country: 'Polen' },
                    { country: 'Storbritannia' },
                ],
                icon: PpIcon,
            })}
            {renderTable({
                title: 'Feriehjem',
                prefix: 'Feriehjem i',
                path: 'feriehus-hytteutleie',
                destinations: [
                    { country: 'Spania' },
                    { country: 'Danmark' },
                    { country: 'Sverige' },
                    { country: 'Italia' },
                    { country: 'Frankrike' },
                ],
                icon: FhhIcon,
            })}
            {renderTable({
                title: 'Leiebil',
                prefix: 'Leiebil i',
                path: 'leiebil',
                destinations: [
                    { city: 'Alicante', country: 'Spania' },
                    { city: 'Nice', country: 'Frankrike' },
                    { city: 'Malaga', country: 'Spania' },
                    { city: 'Gran Canaria', country: 'Spania' },
                    { city: 'München', country: 'Tyskland' },
                ],
                icon: CarIcon,
            })}
        </div>
    );
};
